module.exports = __webpack_public_path__ + "static/media/nut.5baef1bb.png";